export default {
  methods: {
    resetPosition() {
      const { hash } = this.$route;
      if (hash) {
        this.$nextTick(
          () => {
            const element = document.getElementById(hash.replace('#', 'scroll-'));
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          },
        );
      }
    },
  },
};
